// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Container[data-v-cb2d613c]{padding:0 20px}.Action[data-v-cb2d613c]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
